/* eslint-disable max-len */
import { MetadataContent } from '@jutro/legacy/uiconfig';
import React, { useEffect, useContext, useCallback, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import metadata from './MLAgentQuoteStickyAutoComponent.metadata.json5';
import styles from './MLAgentQuoteStickyAutoComponent.module.scss';
import messages from './MLAgentQuoteStickyAutoComponent.messages';

import { IntlContext } from '@jutro/legacy/locale';

const BOOKROLL_WITH_RATE_CAPPING = 'with_Rate_Capping';
const BOOKROLL_WITHOUT_RATE_CAPPING = 'without_ratecapping';

const ACTION_REMOVE_VEHICLE = 'remove';
const ACTION_EDIT_VEHICLE = 'edit';
const VEHICLE_STEP = '/vehicles';

const MLAgentQuoteStickyAutoComponent = (props) => {
    const {
        selectedQuote,
        prevIndex,
        nextIndex,
        isPrevAvailable,
        isNextAvailable,
        coverablesToDisplay,
        onPrevButtonClick,
        onNextButtonClick,
        navigateToStep,
        submissionVM,
        isQuoteLocked,
        forPostQuote,
        isBundle,
        isPurchasePolicyButton,
        canIssuePolicy,
        getNameForMainButton,
        mainButtonFunction,
        getPerTermLabel,
        isPolicyChange,
        hasValidationErrors,
        getQuoteCoverages,
        isMainButtonDisabled,
        isButtonDisabledForPolicyChange,
        getNameForPolicyChangeButton,
        policyChangeButtonFunction
    } = props;
    const translator = useTranslator();
    const intl = useContext(IntlContext);

    const isAlaska7Day = !isPolicyChange && _.get(submissionVM, 'baseData.policyAddress.state.value') === 'AK' && _.get(submissionVM, 'baseData.termType.value');
    const bookrollCode = _.get(submissionVM, 'bookrollInd_ML.value.code');
    const isBookroll = !isPolicyChange && (bookrollCode === BOOKROLL_WITH_RATE_CAPPING || bookrollCode === BOOKROLL_WITHOUT_RATE_CAPPING);
    const termType = isPolicyChange ? _.get(selectedQuote, 'baseData.termType_ML') : _.get(selectedQuote, 'termType_ML');

    const [displayedLineCoverages, setDisplayedLineCoverages] = useState(new Map());
    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);

    const formatAmountString = useCallback((amount) => {
        const premium = _.get(amount, 'amount', 0);
        const currency = _.get(amount, 'currency', 'usd');

        try {
            return intl.formatNumber(premium, { style: 'currency', currency });
        } catch (e) {
            return '';
        }
    }, [intl]);

    const shouldDisplayHeader = (elem) => {
        const currentPosition = window.scrollY;
        const elemTop = elem.offsetTop;
        return (currentPosition >= elemTop);
    };

    const handleScrollEvent = () => {
        const stickyBar = document.getElementById('stickyParentSection');
        const baseEditCoveragesContainer = document.getElementById('editCoveragesBaseContainer');

        if (_.isUndefined(_.get(stickyBar, 'classList', undefined))) {
            return;
        }

        if (baseEditCoveragesContainer) {
            if (baseEditCoveragesContainer && shouldDisplayHeader(baseEditCoveragesContainer)) {
                stickyBar.classList.add(styles.show);
            } else {
                stickyBar.classList.remove(styles.show);
            }
            return;
        }

        if (window.pageYOffset > 0 && window.pageYOffset + window.innerHeight <= document.body.scrollHeight - 300) {
            stickyBar.classList.add(styles.show);
        } else {
            stickyBar.classList.remove(styles.show);
        }
    };

    useEffect(() => {
        handleScrollEvent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        window.addEventListener('scroll', handleScrollEvent);
        return () => {
            window.removeEventListener('scroll', handleScrollEvent);
        };
    });

    const onRemoveVehicle = useCallback((evt) => {
        const vehicleIndex = evt.index;
        const data = {
            action: ACTION_REMOVE_VEHICLE,
            vehicleIndex
        };

        const stepName = VEHICLE_STEP;
        navigateToStep(stepName, data);
    }, [navigateToStep]);

    const onEditVehicle = useCallback((evt) => {
        const vehicle = coverablesToDisplay[evt.index];
        const data = {
            action: ACTION_EDIT_VEHICLE,
            model: vehicle
        };
        const stepName = VEHICLE_STEP;
        navigateToStep(stepName, data);
    }, [coverablesToDisplay, navigateToStep]);

    const isSelectedQuoteStale = useCallback(() => {
        return _.get(selectedQuote, 'quoteStatus.isStale', false) === true;
    }, [selectedQuote]);

    const covAmountDisplayed = useCallback((coverage, vehicle) => {
        if (displayedLineCoverages.has(coverage.code_ML)) {
            const vehId = displayedLineCoverages.get(coverage.code_ML);
            return vehId !== vehicle.publicID;
        }
    }, [displayedLineCoverages]);

    const isNonOwned = (vehicle) => {
        if (vehicle) {
            return vehicle.vehicleName === 'Named Non-Owner';
        }
        return false;
    };

    const getTotalVehiclePremiumPerMonthString = useCallback((vehicle) => {
        const allCoverages = getQuoteCoverages(selectedQuote);
        const lineCoverages = _.get(allCoverages, 'lineCoverages', []);

        let totalLineCovPremium;
        let tempValue;
        let returnObj = vehicle.vehicleMonthlyCost_ML;
        let totalVehMonthlyPremium;
        lineCoverages.forEach((cov) => {
            if (cov.isLineCovCost_Ext === true) {
                tempValue = cov.lineLevelMonthlyCost_Ext.amount;
                if (!covAmountDisplayed(cov, vehicle)) {
                    displayedLineCoverages.set(cov.code_ML, vehicle.publicID);
                    totalLineCovPremium = totalLineCovPremium === undefined ? 0 : totalLineCovPremium;
                    totalLineCovPremium += tempValue;
                    totalVehMonthlyPremium = totalLineCovPremium + vehicle.vehicleMonthlyCost_ML.amount;
                    returnObj = {
                        amount: totalVehMonthlyPremium,
                        currency: 'usd'
                    };
                } else {
                    returnObj = vehicle.vehicleMonthlyCost_ML;
                }
            }
        });

        const formatedAmountValue = formatAmountString(returnObj);
        const perMonthLabel = translator(messages.month);

        return `${formatedAmountValue}/${perMonthLabel}`;
    }, [covAmountDisplayed, displayedLineCoverages, formatAmountString, getQuoteCoverages, selectedQuote, translator]);


    const getTotalVehiclePremiumPerYearString = useCallback((vehicle) => {
        const allCoverages = getQuoteCoverages(selectedQuote);
        const lineCoverages = _.get(allCoverages, 'lineCoverages', []);

        let totalLineCovPremium;
        let tempValue;
        let returnObj = vehicle.vehicleCost_ML;
        let totalVehYearlyPremium;
        lineCoverages.forEach((cov) => {
            if (cov.isLineCovCost_Ext === true) {
                tempValue = cov.lineCovCost_Ext.amount;
                if (!covAmountDisplayed(cov, vehicle)) {
                    displayedLineCoverages.set(cov.code_ML, vehicle.publicID);
                    totalLineCovPremium = totalLineCovPremium === undefined ? 0 : totalLineCovPremium;
                    totalLineCovPremium += tempValue;
                    totalVehYearlyPremium = totalLineCovPremium + vehicle.vehicleCost_ML.amount;
                    returnObj = {
                        amount: totalVehYearlyPremium,
                        currency: 'usd'
                    };
                } else {
                    returnObj = vehicle.vehicleCost_ML;
                }
            }
        });
        const formatedAmountValue = formatAmountString(returnObj);
        const perTermLabel = getPerTermLabel(termType);

        return `${formatedAmountValue}/${perTermLabel}`;
    }, [covAmountDisplayed, displayedLineCoverages, formatAmountString, getPerTermLabel, getQuoteCoverages, selectedQuote, termType]);

    const getNonOwnerDisplayName = (vehicle) => {
        const rawName = _.get(vehicle, 'vehicleName')
        const displayName = rawName === 'Named Non-Owner' && isModernProduct ? 'Non Owner' : rawName;
        return displayName
    }

    const generateVehicleOverrides = useCallback(() => {
        const vehicleOverrides = coverablesToDisplay.map((vehicle, index) => {
            return {
                [`prevIndexSpan${index}`]: {
                    content: prevIndex + (index + 1)
                },
                [`actionContainer${index}`]: {
                    visible: !forPostQuote && !isPolicyChange && !isQuoteLocked && !selectedQuote.isReadOnlyML
                },
                [`spanRemoveVehicle${index}`]: {
                    visible: !isNonOwned(vehicle) && !selectedQuote.isReadOnlyML
                },
                [`nonPolicyChangePremiumH2${index}`]: {
                    visible: !isAlaska7Day && !isPolicyChange,
                    className: isSelectedQuoteStale() && !isBookroll ? 'vehicle-premium strikethrough' : 'vehicle-premium',
                    content: getTotalVehiclePremiumPerMonthString(vehicle)
                },
                [`premiumH2${index}`]: {
                    visible: !isAlaska7Day,
                    className: isSelectedQuoteStale() && !isBookroll ? 'vehicle-premium strikethrough' : 'vehicle-premium',
                    content: getTotalVehiclePremiumPerMonthString(vehicle)
                },
                [`premiumTermP${index}`]: {
                    visible: !isAlaska7Day,
                    className: isSelectedQuoteStale() && !isBookroll ? 'vehicle-term strikethrough' : 'vehicle-term',
                    content: getTotalVehiclePremiumPerYearString(vehicle)
                },
                [`alaskaPremium${index}`]: {
                    visible: isAlaska7Day,
                    content: `${formatAmountString(vehicle.vehicleCost_ML) / getPerTermLabel(termType)}`
                },
                [`vehicleNameSpan${index}`]: {
                    content: getNonOwnerDisplayName(vehicle)
                }
            };
        });

        return Object.assign({}, ...vehicleOverrides);
    }, [coverablesToDisplay, forPostQuote, formatAmountString, getPerTermLabel, getTotalVehiclePremiumPerMonthString, getNonOwnerDisplayName, getTotalVehiclePremiumPerYearString, isAlaska7Day, isBookroll, isPolicyChange, isQuoteLocked, isSelectedQuoteStale, prevIndex, selectedQuote.isReadOnlyML, termType]);

    const overrides = {
        vehicleIterableTopHeader: {
            data: coverablesToDisplay
        },
        nonPolicyChangePremiumPrice: {
            visible: !isPolicyChange,
            content: `${formatAmountString(_.get(selectedQuote, 'selectedPaymentPlan.total'))}/${getPerTermLabel(termType)}`,
            className: (_.get(selectedQuote, 'quoteStatus.isStale', false) || hasValidationErrors(selectedQuote)) && !isBookroll && !isAlaska7Day ? 'premium-price strikethrough' : 'premium-price'
        },
        policyChangePremiumPrice: {
            visible: isPolicyChange,
            content: `${formatAmountString(_.get(selectedQuote, 'fullTermCost_Ext'))}/${getPerTermLabel(termType)}`,
            className: _.get(selectedQuote, 'quoteStatus.isStale', false) ? 'premium-price strikethrough' : 'premium-price'
        },
        totalFees: {
            visible: _.get(selectedQuote, isPolicyChange ? 'totalFullTermChargesRPT_Ext.amount' : 'totalChanges_Ext.amount', 0) > 0,
            totalFees: _.get(selectedQuote, isPolicyChange ? 'totalFullTermChargesRPT_Ext': 'totalChanges_Ext', {}),
            itemizedFees: _.get(selectedQuote, isPolicyChange ? 'fullTermFeesCosts_Ext' : 'feesCosts_Ext', []),
            displayAlternativeTemplate: true
        },
        prevButton: {
            disabled: !isPrevAvailable || isQuoteLocked,
            className: !isPrevAvailable ? 'ml-scrolling-table__header_scroller-control prev prevButton inactive': 'ml-scrolling-table__header_scroller-control prev prevButton'
        },
        nextButton: {
            disabled: !isNextAvailable || isQuoteLocked,
            className: !isNextAvailable ? 'ml-scrolling-table__header_scroller-control next nextButton inactive': 'ml-scrolling-table__header_scroller-control next nextButton'
        },
        nonPolicyChangeButton: {
            visible: !isPolicyChange,
            content: getNameForMainButton ? getNameForMainButton() : undefined,
            onClick: mainButtonFunction,
            disabled: isMainButtonDisabled ? isMainButtonDisabled() : false
        },
        policyChangeButton: {
            visible: isPolicyChange,
            content: getNameForPolicyChangeButton ? getNameForPolicyChangeButton() : undefined,
            disabled: isButtonDisabledForPolicyChange ? isButtonDisabledForPolicyChange() : false,
            onClick: policyChangeButtonFunction
        },
        vehiclePremiumIterable: {
            data: coverablesToDisplay
        },
        ...generateVehicleOverrides()
    };

    const resolvers = {
        resolveCallbackMap: {
            onNextButtonClick,
            onPrevButtonClick,
            onRemoveVehicle,
            onEditVehicle
        },
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
};

MLAgentQuoteStickyAutoComponent.propTypes = {
    selectedQuote: PropTypes.shape({}),
    prevIndex: PropTypes.number,
    nextIndex: PropTypes.number,
    isPrevAvailable: PropTypes.func,
    isNextAvailable: PropTypes.number,
    coverablesToDisplay: PropTypes.arrayOf(PropTypes.shape({})),
    onPrevButtonClick: PropTypes.func,
    onNextButtonClick: PropTypes.func,
    navigateToStep: PropTypes.func,
    submissionVM: PropTypes.shape({}),
    isQuoteLocked: PropTypes.bool,
    forPostQuote: PropTypes.bool,
    isBundle: PropTypes.bool,
    isPurchasePolicyButton: PropTypes.bool,
    canIssuePolicy: PropTypes.bool,
    getNameForMainButton: PropTypes.func,
    mainButtonFunction: PropTypes.func,
    getPerTermLabel: PropTypes.func,
    isPolicyChange: PropTypes.bool,
    hasValidationErrors: PropTypes.func,
    isMainButtonDisabled: PropTypes.func,
    isButtonDisabledForPolicyChange: PropTypes.func,
    getNameForPolicyChangeButton: PropTypes.func,
    policyChangeButtonFunction: PropTypes.func
};

MLAgentQuoteStickyAutoComponent.defaultProps = {
    hasValidationErrors: _.noop
}

export default MLAgentQuoteStickyAutoComponent;